<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" :content="id ? '编辑商家' : '添加商家'"></el-page-header>
        <el-form label-position="right" :model="item" :rules="rules" ref="ruleForm" label-width="auto">
            <el-form-item label="商家名称" prop="businessName">
                <el-input v-model="item.businessName" placeholder="请输入商家名称" :disabled="id ? true : false"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="bankAccount">
                <el-input v-model="item.bankAccount" placeholder="请输入银行账号"></el-input>
            </el-form-item>
            <el-form-item label="银行开户名" prop="bankName">
                <el-input v-model="item.bankName" placeholder="请输入银行开户名"></el-input>
            </el-form-item>
            <el-form-item label="授信额度" prop="bankName">
                <el-input v-model="item.bankName" placeholder="请输入授信额度"></el-input>
            </el-form-item>
            <el-form-item label="法人姓名" prop="legalPerson">
                <el-input v-model="item.legalPerson" placeholder="请输入法人姓名"></el-input>
            </el-form-item>
            <el-form-item label="法人身份证号" prop="idCard">
                <el-input v-model="item.idCard" placeholder="请输入法人身份证号"></el-input>
            </el-form-item>
            <el-form-item label="法人身份证图片" prop="idCardImage" >
                <el-upload multiple list-type="picture" :on-remove="uploadRemove" :on-success="uploadSuccess"
                           :file-list="idCardImage" :on-error="uploadError" drag
                           :action="app_url + '/api/common/upload'" :before-upload="beforeUpload" accept="image/jpeg,image/png">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                        <br/><br/>
                        图片规格：60px x 60px
                    </div>
                </el-upload>
            </el-form-item>

            <el-form-item label="营业执照号" prop="licenseNumber">
                <el-input v-model="item.licenseNumber" placeholder="请输入营业执照号"></el-input>
            </el-form-item>
            <el-form-item label="营业执照图片" prop="licenseImage">
                <el-upload multiple list-type="picture" :on-remove="uploadRemove1" :on-success="uploadSuccess1"
                           :file-list="licenseImage" :on-error="uploadError" drag
                            :action="app_url + '/api/common/upload'" :before-upload="beforeUpload" accept="image/jpeg,image/png">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                        <br/><br/>
                        图片规格：60px x 60px
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="手机号码" prop="mobile">
                <el-input v-model="item.mobile" placeholder="请输入手机号码" :disabled="id? true : false"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" v-if="!id" prop="password">
                <el-input show-password v-model="item.password" placeholder="请输入登陆密码"></el-input>
            </el-form-item>
			<el-form-item>
                    <el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
            <el-form-item>
                <el-dialog
                        title="提示"
                        :visible.sync="dialogVisible"
                        width="30%"
                        >
                    <span>您确认保存嘛</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit">确 定</el-button>
                    </span>
                </el-dialog>
             </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list:[],
                item: {},
                // 对比提交
                items:{},
                oldItem:{},
                isLoad: false,
                id: this.$route.query.id,
                dialogVisible: false,
                idCardImage: [],
                licenseImage: [],
                rules: {
                    businessName: [
                        {required: true, message: '商家名称不存在', trigger: 'blur'},
                    ],
                    bankAccount: [
                        { required: true,validator: this.$check.bankCard, trigger: 'blur' },
                    ],
                    bankName: [
                        {required: true, message: '银行开户名不存在', trigger: 'blur'},
                    ],
                    legalPerson: [
                        {required: true, message: '法人姓名不存在', trigger: 'blur'},
                    ],
                    idCard: [
                        { required: true,validator: this.$check.idCard, trigger: 'blur' },
                    ],
                    idCardImage: [
                        {required: true, message: '法人身份证图片不存在'},
                    ],
                    licenseNumber: [
                        { required: true,validator: this.$check.licenseNumber, trigger: 'blur' },
                    ],
                    licenseImage: [
                        {required: true, message: '营业执照图片不存在'},
                    ],
                    mobile: [
                        { required: true,validator: this.$check.mobile, trigger: 'blur' },
                    ],
                    password: [
                        {required: true, message: '登陆密码不存在', trigger: 'blur'},
                    ]
                }
            }
        },
        created() {
            if (this.id) {
                this.loadData()
            }
        },
        methods: {
            onlyNum(){

            },
            loadData() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.post('/admin/business/detail', {
                    // 请求查询的数据 id为undefined的时候没有值
                    id: this.id
                }).then(res => {
                    this.isLoad = !this.isLoad
                    // item是基础信息
                    this.item = res.data
                    console.log(res.data);
                    // 当图片存在的时候
                    if (this.item.idCardImage) {
                        this.idCardImage = [{
                            // name: this.item.idCardImage,
                            name: '',
                            url: this.item.idCardImage,
                            response: {
                                data: {
                                    src: this.item.idCardImage
                                }
                            }
                        }]
                    }
                    if (this.item.licenseImage) {
                        this.licenseImage = [{
                            name: '',
                            url: this.item.licenseImage,
                            response: {
                                data: {
                                    src: this.item.licenseImage
                                }
                            }
                        }]
                    }
                    // 克隆预原数据
                    this.oldItem = {...res.data}

                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit(){
                // 存储图片且刷新 因为上传的和存储的图片不是同一个
                if (this.idCardImage[0]) {
                    this.$set(this.item,'idCardImage',this.idCardImage[0].response.data.src)
                }else{
                    this.$set(this.item,'idCardImage','')
                }
                if (this.licenseImage[0]) {
                    // this.item.licenseImage = this.licenseImage[0].response.data.src
                    this.$set(this.item,'licenseImage',this.licenseImage[0].response.data.src)
                }else{
                    this.$set(this.item,'licenseImage','')
                }
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.dialogVisible = false

                let url = ''
                if (this.id) {
                    url = '/admin/business/update'

                    // 比较数据项
                    for(var i in  this.oldItem){
                        if(this.oldItem[i] !== this.item[i]){
                            this.items[i] = this.item[i]
                        }
                    }
                    this.item = this.items
                    this.item.id = this.id
                } else {
                    url = '/admin/business/add'
                }

                this.axios.post(url, this.item)
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '保存成功'
                        });
                        this.goBack()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
           uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            },
            beforeUpload(file) {
                var testmsg = file.type;
                const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
                if (!extension ) {
                    this.$message({
                        message: "上传文件只能是jpg或png格式!",
                        type: "warning",
                    });
                }
                return extension;
            },

            uploadSuccess(res, file) {
                file.name = file.raw.name
                // file.name = res.data.src
                this.idCardImage = [file]
                this.$message.success({
                    message: '上传成功'
                });
            },
            uploadRemove: function () {
                this.idCardImage = []
            },

            uploadSuccess1(res, file) {
                file.name = file.raw.name
                this.licenseImage = [file]
                this.$message.success({
                    message: '上传成功'
                });
            },
            uploadRemove1: function () {
                this.licenseImage = []
            }
        }
    }
</script>
<style scoped>
</style>